import React, { useState, useEffect } from "react";
import { Statement } from "../../firebase/statements";
import { useAuth } from "../../firebase/AuthProvider";
import { getStatementSnapshot } from "../../firebase/statements";
import { Grid } from "@material-ui/core";
import { getPrev, getNext } from "./statementNavigation";
import About from "./About";
import StatementHeader from "./StatementHeader";
import Comments from "../comments/Comments";
import StatementNavigationContainer from "./StatementNavigationContainer";
import StatementNavigationButton from "./StatementNavigationButton";
import { useTranslation } from "react-i18next";

interface Props {
  statementId: string;
}

export default function StatementDetail({ statementId }: Props) {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();
  const [statement, setStatement] = useState<Statement | null>(null);
  const [prevStatementSlug, setPrevStatementSlug] = useState<string | null>(
    null
  );
  const [nextStatementSlug, setNextStatementSlug] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (!statementId) setStatement(null);

    const unsubscribe = getStatementSnapshot(
      statementId,
      isAdmin,
      (statement: Statement | null) => {
        setStatement(statement);
        const prevStatementSlug = statement ? getPrev(statement.slug) : null;
        setPrevStatementSlug(prevStatementSlug);
        const nextStatementSlug = statement ? getNext(statement.slug) : null;
        setNextStatementSlug(nextStatementSlug);
      }
    );
    return () => unsubscribe();
  }, [statementId, isAdmin]);

  let buttonLeft;
  let buttonRight;

  if (prevStatementSlug)
    buttonLeft = (
      <StatementNavigationButton to={prevStatementSlug} arrowLeft={true}>
        {t("statement.previous")}
      </StatementNavigationButton>
    );

  if (!prevStatementSlug && nextStatementSlug)
    buttonLeft = (
      <StatementNavigationButton to={"/"} arrowLeft={true}>
        {t("statement.dashboard")}
      </StatementNavigationButton>
    );

  if (nextStatementSlug)
    buttonRight = (
      <StatementNavigationButton to={nextStatementSlug} arrowLeft={false}>
        {t("statement.next")}
      </StatementNavigationButton>
    );

  if (!statement) return null;

  return (
    <Grid container item direction="column">
      <Grid container item>
        <StatementHeader
          statement={statement}
          statementNavigation={
            <StatementNavigationContainer
              buttonLeft={buttonLeft}
              buttonRight={buttonRight}
            />
          }
        />
      </Grid>
      <Grid container item>
        <About statement={statement} />
      </Grid>
      <Grid container item>
        <Comments statement={statement} />
      </Grid>
    </Grid>
  );
}
